// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Footer----index-module---wrapper---15J7S","list":"src-components-Footer----index-module---list---2IXhR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/index.module.css
// module id = 323
// module chunks = 114276838955818